import { defineMessages } from 'react-intl';

const messages = defineMessages({
  introduction: {
    id: 'MarketVideo.introduction',
    defaultMessage: 'What is Sorare',
  },
  getStarted: {
    id: 'MarketVideo.getStarted',
    defaultMessage: 'Get Started',
  },
  scoring: {
    id: 'MarketVideo.scoring',
    defaultMessage: 'Scoring System',
  },
  competitions: {
    id: 'MarketVideo.competitions',
    defaultMessage: 'Competitions',
  },
});

export const marketVideo = {
  key: 'market',
  default: {
    src: 'https://www.youtube.com/embed/Ibi_7vUWHNA?si=bwfyZZzQTGioZZoJ&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/Ibi_7vUWHNA/hqdefault.jpg',
    duration: 1,
  },
  'fr-FR': {
    src: 'https://www.youtube.com/embed/QGLr2E55C20?si=opgR5ZyzbvTRJCdf&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/QGLr2E55C20/hqdefault.jpg',
    duration: 1,
  },
  'es-ES': {
    src: 'https://www.youtube.com/embed/-fK_nYvpLJk?si=jZ2Z6Sxx9qmV7tou&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/-fK_nYvpLJk/hqdefault.jpg',
    duration: 1,
  },
  'it-IT': {
    src: 'https://www.youtube.com/embed/LP3R6EwdbUM?si=jQw2m4Gqfl85B6Cv&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/LP3R6EwdbUM/hqdefault.jpg',
    duration: 1,
  },
  'de-DE': {
    src: 'https://www.youtube.com/embed/5dBBM5Uu5qI?si=sJ3sL9Lko8mShgQc&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/5dBBM5Uu5qI/hqdefault.jpg',
    duration: 1,
  },
};

export const introductionVideo = {
  key: 'introduction',
  title: messages.introduction,
  default: {
    src: 'https://www.youtube.com/embed/RVsgESV0uvo?si=2TiIxjB051hvotGw&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/RVsgESV0uvo/hqdefault.jpg',
    duration: 1,
  },
  'fr-FR': {
    src: 'https://www.youtube.com/embed/ZocvLbKKB1g?si=h6A6hUSvAdCqvY_-&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/ZocvLbKKB1g/hqdefault.jpg',
    duration: 1,
  },
  'es-ES': {
    src: 'https://www.youtube.com/embed/gbE-hQG2o08?si=n8Sj7otLkOeKwapr&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/gbE-hQG2o08/hqdefault.jpg',
    duration: 1,
  },
  'it-IT': {
    src: 'https://www.youtube.com/embed/r4gZdr_oMYA?si=ALJ7mXtvf7iQK4sH&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/r4gZdr_oMYA/hqdefault.jpg',
    duration: 1,
  },
  'de-DE': {
    src: 'https://www.youtube.com/embed/IVHzHqe22vQ?si=8-nZ_NkX6zIVFXMI&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/IVHzHqe22vQ/hqdefault.jpg',
    duration: 1,
  },
};

export const getStartedVideo = {
  key: 'getStarted',
  title: messages.getStarted,
  default: {
    src: 'https://www.youtube.com/embed/Q30ajmX4zfg?si=sXugmcL5R4WFwrQt&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/Q30ajmX4zfg/hqdefault.jpg',
    duration: 1,
  },
  'fr-FR': {
    src: 'https://www.youtube.com/embed/A1KheFEO1vI?si=RWZmfdIuK4RoEr8U&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/A1KheFEO1vI/hqdefault.jpg',
    duration: 1,
  },
  'es-ES': {
    src: 'https://www.youtube.com/embed/otNXRaDOVyA?si=NkwBztUpG4prwxeD&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/otNXRaDOVyA/hqdefault.jpg',
    duration: 1,
  },
  'it-IT': {
    src: 'https://www.youtube.com/embed/EbWC6J4vlK8?si=48bvAfydu405bDJp&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/EbWC6J4vlK8/hqdefault.jpg',
    duration: 1,
  },
  'de-DE': {
    src: 'https://www.youtube.com/embed/ts-2DGuM7oQ?si=Wk4bLSrcRM80pon4&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/ts-2DGuM7oQ/hqdefault.jpg',
    duration: 1,
  },
};

export const scoringVideo = {
  key: 'scoring',
  title: messages.scoring,
  default: {
    src: 'https://www.youtube.com/embed/1PVU7ldJSDM?si=noZvVDatrJICyv73&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/1PVU7ldJSDM/hqdefault.jpg',
    duration: 1,
  },
  'fr-FR': {
    src: 'https://www.youtube.com/embed/W_CZpSLCkyQ?si=IMulCHv69vg7ndy1&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/W_CZpSLCkyQ/hqdefault.jpg',
    duration: 1,
  },
  'es-ES': {
    src: 'https://www.youtube.com/embed/uXf7ENrDhQ8?si=LB6OU9__V0zTtt0c&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/uXf7ENrDhQ8/hqdefault.jpg',
    duration: 1,
  },
  'it-IT': {
    src: 'https://www.youtube.com/embed/JnenL6VB8WI?si=ulfxgIr-r9y9vgNx&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/JnenL6VB8WI/hqdefault.jpg',
    duration: 1,
  },
  'de-DE': {
    src: 'https://www.youtube.com/embed/KUi6ledqB9M?si=l12Rptctcjqpd98a&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/KUi6ledqB9M/hqdefault.jpg',
    duration: 1,
  },
};

export const competitionsVideo = {
  key: 'competitions',
  title: messages.competitions,
  default: {
    src: 'https://www.youtube.com/embed/ewjdbFZ5yIk?si=Jec4Y3UkSAAxNzug&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/ewjdbFZ5yIk/hqdefault.jpg',
    title: messages.competitions,
    duration: 2,
  },
  'fr-FR': {
    src: 'https://www.youtube.com/embed/LIO0JVBIY84?si=RzYyeqPq27RJVnkY&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/LIO0JVBIY84/hqdefault.jpg',
    duration: 1,
  },
  'es-ES': {
    src: 'https://www.youtube.com/embed/LthwqYt6oVU?si=vCWNd63JcCcfZMBE&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/LthwqYt6oVU/hqdefault.jpg',
    duration: 1,
  },
  'it-IT': {
    src: 'https://www.youtube.com/embed/8S6r36qMI_o?si=ojt1QwFa80TMt5H-&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/8S6r36qMI_o/hqdefault.jpg',
    duration: 2,
  },
  'de-DE': {
    src: 'https://www.youtube.com/embed/uDK81ZkUM_U?si=lWwB7S-NyrukODmf&autoplay=1&rel=0',
    thumbnail: 'https://img.youtube.com/vi/uDK81ZkUM_U/hqdefault.jpg',
    duration: 1,
  },
};
